import Panel from 'components/Panel'
import styled, { css } from 'styled-components'
import FontAwesome from 'react-fontawesome'
import Form from './Form'
import Actions from './FootprintActions'
import Suggestions from './Suggestions'

const Container = styled.div`
  ${(props) =>
    props.expanded &&
    css`
      width: 600px;
      left: 50%;
      transform: translate(-50%, 0);
      top: 30px;
      z-index: 1100;
    `}
`

const StyledPanel = styled(Panel)`
  border-color: var(--main-color);
  .input-group {
    margin-bottom: 10px;
  }
`

const CloseButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  -webkit-text-stroke: 1px var(--main-color);

  .fa {
    font-size: 20px;
  }
`

const Footprints = ({
  footprints,
  handleClose,
  expanded,
  toggleExpand,
  handleLinkClick,
  user,
  ...formProps
}) => {
  if (!footprints.active) {
    return null
  }
  const customer = user.careassist.name

  const panelButtons = (
    <span>
      <CloseButton onClick={handleClose}>
        <FontAwesome name="times-circle-o" />
      </CloseButton>
    </span>
  )

  return (
    <div className={expanded ? 'modal' : ''} style={{ display: 'block' }}>
      <Container expanded={expanded} className="container">
        <StyledPanel title="PawPrints" blue buttons={panelButtons}>
          <Form {...formProps} footprints={footprints} />

          <Actions
            actions={footprints.actions}
            handleLinkClick={handleLinkClick}
          />

          <Suggestions
            suggestions={footprints.suggestions}
            handleLinkClick={handleLinkClick}
            customer={customer}
          />
        </StyledPanel>
      </Container>
    </div>
  )
}

export default Footprints
